import React, { useEffect, useState, useRef } from 'react';
import HomeLayout from '../../components/home_page/HomeLayout';
import Form from '../../components/Form/Form';
import MasterListFooter from '../../components/Footer/Master_Footer/MasterListFooter';
import NavFooterLayout from '../../components/NavNameOfComponent/NavFooterLayout';
import { useDropdownKeyboardNavigation } from '../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import { useDropdownScroll } from '../../components/Custom_Hooks/useDropdownScroll';
import BranchCreateModal from './BranchCreateModal';

const initialBranchDataList = [
    { name: "Pachore Road", branch_code: "11", address: "Boda", under: "Main Location", branch_manager: "Kamal Kushwah", mobile: "9874563210", status: "Active" },
    { name: "Pachore", branch_code: "74", address: "Pachore", under: "Primary", branch_manager: "Amar Dubey", mobile: "9617965916", status: "Inactive" }
];

function BranchCreate() {
    const [loading, setLoading] = useState(true);
    const [all_data, setAll_data] = useState([]);
    const [enabled, setEnabled] = useState(true);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            setAll_data(initialBranchDataList);
            setLoading(false);
        }, 150);
        return () => clearTimeout(timer);
    }, []);

    // Handle Alt+C or C shortcut key from the table list
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: all_data,
        state: !isCreateOpen,
        initialIndex: 0,
        enableAlphaJump: true,
        getLabel: (item) => item?.name || '',
        onItemAltCSelect: () => {
            setIsCreateOpen(true);
        }
    });

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    // Handle successful creation of branch
    const handleBranchCreated = (newBranchData) => {
        setAll_data(prev => [...prev, newBranchData]);
    };

    // Custom layout click handler for mouse users clicking "Create Master" in the footer
    useEffect(() => {
        const handleFooterClick = (e) => {
            const buttonElement = e.target.closest('button');
            if (buttonElement && buttonElement.textContent.includes('Create Master')) {
                if (!isCreateOpen) {
                    setIsCreateOpen(true);
                }
            }
        };
        document.addEventListener('click', handleFooterClick);
        return () => document.removeEventListener('click', handleFooterClick);
    }, [isCreateOpen]);

    return (
        <HomeLayout>
            {isCreateOpen && (
                <div style={{ zIndex: 10000 }}>
                    <BranchCreateModal
                        closeModal_sec={() => setIsCreateOpen(false)}
                        onSuccess={handleBranchCreated}
                    />
                </div>
            )}
            <Form
                title='Branch Management'
                col='col-12'
                loading={loading}
                Footer={MasterListFooter}
                createMasterEnabled={enabled}
            >
                <div className="row p-0 m-0 border_2_1px_top border_2_2px_bottom mt-0">
                    <div
                        className="col-1 font_size p-0 m-0 px-1 text-end fw-bold"
                        style={{ width: "5%" }}
                    >
                        Sr No.
                    </div>
                    <div
                        className="col-3 font_size p-0 m-0 px-1 text-start fw-bold"
                        style={{ width: "25%" }}
                    >
                        Branch Name
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "10%" }}
                    >
                        Branch Code
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "13%" }}
                    >
                        Address
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "12%" }}
                    >
                        Under
                    </div>
                    <div
                        className="col-2 font_size m-0 p-0 px-1 text-start fw-bold"
                        style={{ width: "15%" }}
                    >
                        Branch Manager
                    </div>
                    <div
                        className="col-1 font_size m-0 p-0 px-1 text-end fw-bold"
                        style={{ width: "12%" }}
                    >
                        Mobile
                    </div>
                    <div
                        className="col-1 font_size p-0 m-0 px-1 text-start fw-bold"
                        style={{ width: "8%" }}
                    >
                        Branch Status
                    </div>
                </div>
                <div className='row gx-0 p-0 mb-2' style={{ overflowY: 'hidden' }}>
                    <div className='col m-0 p-0' ref={dropdownRef} style={{ overflowY: 'auto', height: '75.3vh' }}>
                        {
                            all_data.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => setSelectedItemIndex(index)}
                                        style={{ cursor: "pointer" }}
                                        className={`row gx-0 p-0 m-0 mt-0 ${index === selectedItemIndex ? "selected" : ""}`}
                                    >
                                        <div
                                            className="col-1 font_size p-0 m-0 px-1 text-end"
                                            style={{ width: "5%" }}
                                        >
                                            {index + 1}
                                        </div>
                                        <div
                                            className="col-3 font_size p-0 m-0 px-1 text-start"
                                            style={{ width: "25%" }}
                                        >
                                            {item?.name}
                                        </div>
                                        <div
                                            className="col-1 font_size m-0 p-0 px-1 text-end"
                                            style={{ width: "10%" }}
                                        >
                                            {item?.branch_code}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 px-1 text-start"
                                            style={{ width: "13%" }}
                                        >
                                            {item?.address}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 px-1 text-start"
                                            style={{ width: "12%" }}
                                        >
                                            {item?.under}
                                        </div>
                                        <div
                                            className="col-2 font_size m-0 p-0 px-1 text-start"
                                            style={{ width: "15%" }}
                                        >
                                            {item?.branch_manager}
                                        </div>
                                        <div
                                            className="col-1 font_size m-0 p-0 px-1 text-end"
                                            style={{ width: "12%" }}
                                        >
                                            {item?.mobile}
                                        </div>
                                        <div
                                            className="col-1 font_size p-0 m-0 px-1 text-start fw-bold"
                                            style={{
                                                width: "8%",
                                                color: item?.status === 'Active' ? '#198754' : '#dc3545'
                                            }}
                                        >
                                            {item?.status}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <NavFooterLayout>
                    <b className='ps-2'> {all_data.length} Branch(es)</b>
                </NavFooterLayout>
            </Form>
        </HomeLayout>
    )
}

export default BranchCreate;
